<template>
  <div style="width: 1660px;height: 820px;background-color: #aaa;overflow: hidden;">
    <div style="width: 49.9%;float: left;background-color: #fff;height: 100%;">
      <div class="left_right">
        <div style="width: 720px;margin: 0 auto;overflow: hidden;border-bottom: 3px solid #ff6700;">
          <span style="font-size: 16px;font-weight: bold;color: #333;line-height: 33px;">
            订单咨询
          </span>
          <span style="float: right;line-height: 33px;">
            <span style="margin-right: 10px;">
              <el-button type="success" icon="el-icon-refresh-right" circle size="mini" @click="queryPrivatesnow"></el-button>
            </span>
          </span>
        </div>
        <div style="width: 720px;margin: 0 auto;overflow: hidden;margin-top: 5px;">
          <div style="overflow: hidden;text-align: center;margin-top: 300px;" v-if="pageTotal<=0" v-loading="loading">
            <i class="el-icon-position"></i>    暂时没有咨询消息
          </div>
          <div style="min-height: 720px;" v-loading="loading" v-else>
            <div style="width: 720px;overflow: hidden;margin-top: 5px;" v-for="privates in privatelist" :key="privates.c_id" id=""><!--循环体-->
              <router-link to="" @click.native="routerGOorderzx(privates.c_id,privates._name,privates._id,privates.order_id)">
                <div class="openprivate">
                  <div style="width: 72px;height: 71px;border:1px solid #aaa;float: left;text-align: center;">
                    <img :src="privates._photo" alt="" style="width: 70px;height: 70px;margin: 0 auto;">
                  </div>
                  <div style="float: right;width: 630px;min-height: 50px;overflow: hidden;">
                    <div style="width: 620px;margin: 0 auto;margin-bottom: 5px;font-size: 14px;overflow: hidden;">
                      <div style="margin-top: 5px;overflow: hidden;font-size: 14px;margin-bottom: 5px;">
                        <router-link to="" style="color: #1fa1f1;">
                          <a href="javascript:;" style="color: #1fa1f1;" @click="openOrderInfor(privates.order_id)">
                            订单号：{{privates.order_id}}
                          </a>
                        </router-link>
                        <span style="float: right;color: #8f8f8f;">{{privates._time*1 | formatDate}} <i class="el-icon-time"></i></span>
                      </div>
                      <div style="margin-top: 5px;overflow: hidden;">
                        <span style="color: #1fa1f1;">
                          咨询人：{{privates._name}}
                        </span>
                      </div>
                      <div style="margin-top: 5px;overflow: hidden;">
                        <div style="width: 560px;float: left;overflow: hidden;">
                          <div class="title">
                              {{privates._content}}
                          </div>
                        </div>
                        <div style="width: 60px;float: right;overflow: hidden;text-align: right;">
                          <router-link to="" style="color: #1fa1f1;">
                            <a href="javascript:;" style="color: #1fa1f1;" @click="deleteupdatePrivates(privates)">
                              删除
                            </a>
                          </router-link>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </router-link>
              <div style="width: 720px;overflow: hidden;height: 5px;"></div>
              <hr style="width: 720px;margin-top: 5px;overflow: hidden;">
            </div>
          </div>
          <div style="width: 720px;margin-top: 10px;overflow: hidden;margin-bottom: 20px;text-align: center;" v-if="pageTotal>0">
            <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="UserInfor.pageNum"
             :page-size="UserInfor.pageSize" layout="prev, pager, next" :total="pageTotal">
            </el-pagination>
          </div>
        </div>
      </div>
    </div>
    <div style="width: 49.9%;float: right;background-color: #fff;height: 100%;">
      <div class="left_right">
        <el-tabs v-model="editableTabsValue" type="card" @edit="handleTabsEdit">
          <el-tab-pane
            :key="item.name"
            v-for="(item, index) in editableTabs"
            :label="item.title"
            :name="item.name"
            :closable="item.close"
          >
            <component :is="item.content"></component>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>

    <!--详细订单信息-->
    <div class="Orderinfordiv" id="Orderinformain">
      <div class="OrderinforForm">
        <!--头部标签-->
        <div style="width: 100%;height: 40px;background-color: #2d2d2d;">
          <span style="line-height: 40px;color: #FFFFFF;font-size: 14px;float: left;margin-left: 20px;">
            订单详情
            <span v-if="orderinforList.type=='0'">（等待付款）</span>
            <span v-else-if="orderinforList.type=='1'">（等待发货）</span>
            <span v-else-if="orderinforList.type=='2'">（等待收货）</span>
            <span v-else-if="orderinforList.type=='3'">（待评价）</span>
            <span v-else-if="orderinforList.type=='4'">（已完成）</span>
            <span v-else-if="orderinforList.type=='6'">（备货中）</span>
            <span v-else-if="orderinforList.type=='8'">（退款申请驳回）</span>
            <span v-else-if="orderinforList.type=='-1'">（已取消）</span>
            <span v-else-if="orderinforList.type=='5'">（退款中）</span>
            <span v-else-if="orderinforList.type=='7'">（退款成功/已取消）</span>
            <span v-else-if="orderinforList.type=='-2'">（用户已删除）</span>
          </span>
          <span style="line-height: 40px;color: #FFFFFF;font-size: 14px;float: right;margin-right: 20px;">
            <a href="javascript:;" @click="closeOrderInformation()">
              <i class="el-icon-close"></i>
            </a>
          </span>
        </div>
        <!--主体结构-->
        <div class="playlistbox_botton" v-loading="loadingxx">
          <div style="margin-bottom: 10px;margin-top: 10px;overflow: hidden;">
            <div style="line-height: 26px;width: 900px;overflow: hidden;">
              <div style="width: 880px;margin: 0 auto;">
                <div style="float: left;font-size: 20px;color: #909090;">
                  订单详情
                </div>
                <div style="float: right;line-height: 26px;">
                  <!--咨询位置-->
                </div>
              </div>
            </div>
            <!--订单编号-->
            <div style="margin-top: 10px;color: #909090;float: left;width: 900px;overflow: hidden;margin-bottom: 11px;">
              <div style="width: 880px;margin: 0 auto;">
                <div style="float: left;">
                  订单号：{{orderinforList.id}}
                </div>
              </div>
            </div>
            <!--分割线-->
            <hr>
            <!--商品与订单状态-->
            <div style="width: 870px;overflow: hidden;margin: 0 auto;">
              <div style="color: #ff6700;font-size: 17px;" v-if="orderinforList.type=='0'">
                等待付款
              </div>
              <div style="color: #ff6700;font-size: 17px;" v-else-if="orderinforList.type=='1'">
                等待发货
              </div>
              <div style="color: #ff6700;font-size: 17px;" v-else-if="orderinforList.type=='2'">
                等待收货
              </div>
              <div style="color: #ff6700;font-size: 17px;" v-else-if="orderinforList.type=='3'">
                已成交（待评价）
              </div>
              <div style="color: #ff6700;font-size: 17px;" v-else-if="orderinforList.type=='4'">
                已成交
              </div>
              <div style="color: #ff6700;font-size: 17px;" v-else-if="orderinforList.type=='6'">
                备货中
              </div>
              <div style="color: #ff6700;font-size: 17px;" v-else-if="orderinforList.type=='8'">
                退款申请驳回
              </div>
              <div style="color: #ff6700;font-size: 17px;" v-else-if="orderinforList.type=='-1'">
                已取消
              </div>
              <div style="color: #ff6700;font-size: 17px;" v-else-if="orderinforList.type=='5'">
                退款中（等待商家确认）
              </div>
              <div style="color: #ff6700;font-size: 17px;" v-else-if="orderinforList.type=='7'">
                退款成功/已取消
              </div>
              <div style="color: #ff6700;font-size: 17px;" v-else-if="orderinforList.type=='-2'">
                用户已删除
              </div>
              <div style="margin-top: 5px;" v-if="orderinforList!=''">
                <el-collapse>
                  <el-collapse-item :title="getNewTypetime(orderinforList.timeList[0])">
                    <div>
                      <el-timeline>
                        <el-timeline-item
                          v-for="(activity, index) in orderinforList.timeList"
                          :key="index"
                          :timestamp="activity.time*1 | formatDate"
                          color="#0bbd87">
                          {{PDTimeType(activity.type)}}
                        </el-timeline-item>
                      </el-timeline>
                    </div>
                  </el-collapse-item>
                </el-collapse>
              </div>

              <!--商品列表-->
              <div style="overflow: hidden;margin-bottom: 5px;margin-top: 10px;" v-for="(goods,index) in orderinforList.goodsList" :key="index"><!--多个商品循环区域-->
                <div v-if="orderinforList.id.substr(0, 1)=='9'"><!--普通订单类型-->
                  <div style="width: 75px;height: 75px;float: left;">
                    <a href="javascript:;" @click="routerPage(goods.g_id)">
                      <img :src="goods.image" alt="" width="75px" height="75px">
                    </a>
                  </div>
                  <div style="float: left;margin-left: 25px;font-size: 14px;line-height: 75px;">
                    <div style="width: 100%;overflow: hidden;">
                      <a href="javascript:;" style="color: #000000;" @click="routerPage(goods.g_id)">
                        <div class="titleOrder_infor" style="float: left;">
                          {{goods.name}}
                        </div>
                      </a>
                      <span style="margin-left: 15px;">
                        {{getFmoney(goods.money,goods.discount)}}元✖{{goods.number}}
                      </span>
                      <span style="margin-left: 15px;">
                        折扣值：
                        <span v-if="goods.discount>=1">
                          无折扣
                        </span>
                        <span v-else>
                          <span style="font-size: 15px;color: #ff6700;">
                            {{goods.discount*10}}
                          </span>
                          折
                        </span>
                      </span>
                    </div>
                  </div>
                </div>
                <div v-else-if="orderinforList.id.substr(0, 1)=='8'"><!--自定义订单信息-->
                  <div style="width: 102px;height: 102px;float: left;border: 1px solid #aaaaaa;">
                    <img :src="goods.image" alt="" width="100px" height="100px">
                  </div>
                  <div style="float: left;margin-left: 25px;font-size: 14px;">
                    <div style="line-height: 50px;width: 730px;">
                      {{goods.name}}
                    </div>
                    <div style="line-height: 50px;">
                      {{getFmoney(orderinforList.sum_money*1,1)}}元✖{{1}}
                    </div>
                  </div>
                </div>

              </div>
            </div>
            <!--分割线-->
            <hr>
            <!--收货信息-->
            <div style="width: 880px;overflow: hidden;margin: 0 auto;margin-top: 5px;">
              <div style="font-size: 20px;font-weight: normal;color:#000;overflow:hidden;margin-bottom: 5px;">收货信息</div>
              <p class='orderxx_p'>姓<span style="color:#fff">姓名</span>名：{{orderinforList.consignee}}</p>
              <p class='orderxx_p'>联系电话：{{orderinforList.phone}}</p>
              <p class='orderxx_p'>收货地址：{{orderinforList.address}}</p>
            </div>
            <!--分割线-->
            <hr>
            <!--支付信息-->
            <div style="width: 880px;overflow: hidden;margin: 0 auto;margin-top: 5px;">
              <div style="font-size: 20px;font-weight: normal;color:#000;overflow:hidden;margin-bottom: 5px;">支付方式</div>
              <p class='orderxx_p'>支付方式：在线支付</p>
            </div>
            <!--分割线-->
            <hr>
            <!--订单金额总计-->
            <div>
              <table border="0" align="right" width="50%" >
              	<tr>
              		<td width="70%"><div align="right">商品总价：</div></td>
              		<td><div align="right" style="color:#ff6700;">{{parseFloat(parseFloat(orderinforList.sum_money)-parseFloat(orderinforList.freight)).toFixed(2)}}元</div></td>
              	</tr>
              	<tr>
              		<td><div align="right">运费：</div></td>
              		<td><div align="right" style="color:#ff6700;">{{parseFloat(orderinforList.freight).toFixed(2)}}元</div></td>
              	</tr>
              	<tr>
              		<td><div align="right">&nbsp;</div></td>
              		<td><div align="right">&nbsp;</div></td>
              	</tr>
              	<tr>
              		<td><div align="right">应付金额：</div></td>
              		<td><div align="right" style="color:#ff6700;"><span style="font-size:30px;">{{parseFloat(orderinforList.sum_money).toFixed(2)}}</span>元</div></td>
              	</tr>
              </table>
            </div>

          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
  import AConsulationinfor from '@/admin/views/consulation_admin/AConsulationinfor'//首页通知页
  import {commonAPI} from '@/api/commonAPI'
export default {
  components: {
    'AConsulationinfor-bar': AConsulationinfor,
  },
  data () {
      return {
        editableTabsValue: '1',
        editableTabs: [],
        tabIndex: 1,

        privatelist:'',

        deleteprivate:{
          c_id:'',
          admin_id:'',
        },

        //用户相关信息
        UserInfor:{
          admin_id:'',
          pageNum:1,
          pageSize:6,
        },
        pageTotal:0,
        //订单详情
        orderinforList:'',
        orderxx:{},
        //打开订单信息判断
        orderzxxx_pd:0,

        loading:false,
        loadingxx:false,
      }
    },

    filters: {
          formatDate: function (value) {
            /*返回总体日期*/
            let date = new Date(value);
            let y = date.getFullYear();
            let MM = date.getMonth() + 1;
            MM = MM < 10 ? ('0' + MM) : MM;
            let d = date.getDate();
            d = d < 10 ? ('0' + d) : d;
            let h = date.getHours();
            h = h < 10 ? ('0' + h) : h;
            let m = date.getMinutes();
            m = m < 10 ? ('0' + m) : m;
            let s = date.getSeconds();
            s = s < 10 ? ('0' + s) : s;
            //return y + '-' + MM + '-' + d + ' ' + h + ':' + m + ':' + s;
            /*返回判断日期*/
            let timestamp = (new Date()).valueOf();
            let time=timestamp-value;//时间差
            let minute = 1000*60;
            let hour = minute * 60;
            var day = hour * 24;
            let times="";//内容
            let min = time/minute;//分钟
            let hours = time/hour;//天数
            if(time>=0 && time<minute){
              times="刚刚";
              return times;
            }else if(min>=1 && min<60){
              times=parseInt(min)+"分钟前";
              return times;
            }else if(hours>=1&&hours<24&&new Date(value).toDateString() == new Date().toDateString()){
              return MM+'-'+d+' '+h + ':' + m ;
            }else{
              return y + '-' + MM + '-' + d + ' ' + h + ':' + m;
            }
          }
        },

    mounted(){
        this.queryPrivatesnow();
      },


    methods: {
      //
      handleTabsEdit(targetName, action) {
        if (action === 'remove') {
          let tabs = this.editableTabs;
          let activeName = this.editableTabsValue;
          if (activeName === targetName) {
            tabs.forEach((tab, index) => {
              if (tab.name === targetName) {
                let nextTab = tabs[index + 1] || tabs[index - 1];
                if (nextTab) {
                  activeName = nextTab.name;
                }
              }
            });
          }
          this.editableTabsValue = activeName;
          this.editableTabs = tabs.filter(tab => tab.name !== targetName);
        }
      },
      //删除私信
      deleteupdatePrivates(privates){
        this.orderzxxx_pd=1;
        this.$confirm('确认删除与该用户的对话?', '提示', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  type: 'warning'
                }).then(() => {
                  this.deleteprivate.c_id=privates.c_id;
                  this.deleteprivate.admin_id=this.UserInfor.admin_id;
                  commonAPI('AupdateConsulation', this.deleteprivate).then(res => {
                    let data = res.data;
                    if(this.response.response(data)){
                      this.orderzxxx_pd=0;
                      this.deleteprivate.u_id="";
                      this.deleteprivate.c_id="";
                      this.queryPrivatesnow();
                    }
                  }).catch(error=>{
                        this.$notify({//这里采用element ui的一个错误显示效果模板
                          title: '提示',
                          message: error.message,
                          position: 'bottom-right',
                          type: 'error'
                        });
                  });
                }).catch(() => {
                  this.orderzxxx_pd=0;
                });
      },
      //更新当前私信
      queryPrivatesnow(){
        this.loading=true;
        this.UserInfor.admin_id=this.$store.state.a_id;
        commonAPI('AqueryConsulation', this.UserInfor).then(res => {
          this.privatelist=res.data.data.rows;
          this.pageTotal=res.data.data.total;
          this.loading=false;
        })
      },
      //
      handleCurrentChange(val) {
        //console.log(`当前页: ${val}`);
        this.UserInfor.pageNum=val;
        this.queryPrivatesnow();
      },
      handleSizeChange(val) {
        //console.log(`每页 ${val} 条`);
        this.UserInfor.pageSize=val;
        this.UserInfor.pageNum=1;
        this.queryPrivatesnow();
      },
      //订单咨询跳转
      routerGOorderzx(id,admin_name,admin_id,order_id){
        if(this.orderzxxx_pd==1){
          return false;
        }
        sessionStorage.removeItem("orderzx_infor");
        let list=[];
        list.push(id)
        list.push(admin_name)
        list.push(admin_id)
        list.push(order_id)
        sessionStorage.setItem("orderzx_infor",JSON.stringify(list));
        let cc=sessionStorage.getItem("orderzx_infor");
        cc = JSON.parse(cc);
        //console.log(list)
        //console.log(cc)
        /**
         * 页面跳转
         * */
        //this.$router.push({name: 'Aconsulation'});
        //this.$router.push({name: 'Aconsulationinfor'});
        let title=admin_name+":"+order_id;
        this.ADDTabPage(title,'AConsulationinfor-bar');
      },
      //添加新标签页面
      ADDTabPage(Title,Contents){
        let PD_I=0;
        let PD=0;
        for(let i=0;i<this.editableTabs.length;i++){
          if(Title==this.editableTabs[i].title){
            PD_I=1;
            PD=i;
            break;
          }
        }
        if(PD_I==1){
          this.editableTabsValue=this.editableTabs[PD].name;
          return false;
        }else if(this.editableTabs.length>0){
          this.handleTabsEdit(this.editableTabs[0].name,"remove");
        }
        const thisComp = Contents;
        let newTabName = ++this.tabIndex + '';
        this.editableTabs.push({
          title: Title,
          name: newTabName,
          close:true,
          content: thisComp
        });
        this.editableTabsValue = newTabName;
        //this.setCookie(1);
      },

      //价钱浮动计算方法
      getFmoney(money,discount){
        let m=0,s1=money.toString(),s2=discount.toString(),sum=0;
        try{m+=s1.split(".")[1].length}catch(e){}
        try{m+=s2.split(".")[1].length}catch(e){}
        sum=Number(s1.replace(".",""))*Number(s2.replace(".",""))/Math.pow(10,m);
        return sum.toFixed(2);
      },

      //打开或者关闭订单详情
      openOrderInfor(id){
        this.orderzxxx_pd=1;
        this.getOrderInforList(id);
        document.getElementById('Orderinformain').style.display='block';
        document.getElementById('zhedang').style.display='block';
      },
      closeOrderInformation(){
        this.orderinforList='';
        this.orderzxxx_pd=0;
        document.getElementById('Orderinformain').style.display='none';
        document.getElementById('zhedang').style.display='none';
      },
      //获取订单详情
      getOrderInforList(id){
        this.loadingxx=true;
        if(id==''||id=='null'||id=='undefined'){
          return false;
        }
        this.orderxx.id=id;//订单ID
        this.orderxx.pageNum=1;
        this.orderxx.pageSize=1;
        commonAPI('queryOrders_list_infor', this.orderxx).then(res => {
          this.orderinforList=res.data.data.rows[0];
          this.loadingxx=false;
        })
      },

      //进行订单的最新状态
      getNewTypetime(data){
        if(data==''||data==null||data=='undefined'){
          return false;
        }
        let text="时间："+this.formatDate(data.time*1)+"         当前状态："+this.PDTimeType(data.type);
        return text;
      },
      //判定订单当前时间状态
      PDTimeType(data){
        let text='';
        if(data=='0'){
          text='订单创建';
        }else if(data=='1'){
          text='订单付款';
        }else if(data=='2'){
          text='订单发货';
        }else if(data=='3'){
          text='订单成交';
        }else if(data=='4'){
          text='订单评价';
        }else if(data=='5'){
          text='订单退款中';
        }else if(data=='6'){
          text='订单备货中';
        }else if(data=='7'){
          text='订单退款';
        }else if(data=='8'){
          text='订单退款申请驳回';
        }else if(data=='-1'){
          text='订单取消';
        }
        return text;
      },

      //时间转换
      formatDate: function (value) {
        /*返回总体日期*/
        let date = new Date(value);
        let y = date.getFullYear();
        let MM = date.getMonth() + 1;
        MM = MM < 10 ? ('0' + MM) : MM;
        let d = date.getDate();
        d = d < 10 ? ('0' + d) : d;
        let h = date.getHours();
        h = h < 10 ? ('0' + h) : h;
        let m = date.getMinutes();
        m = m < 10 ? ('0' + m) : m;
        let s = date.getSeconds();
        s = s < 10 ? ('0' + s) : s;
        //return y + '-' + MM + '-' + d + ' ' + h + ':' + m + ':' + s;
        /*返回判断日期*/
        let timestamp = (new Date()).valueOf();
        let time=timestamp-value;//时间差
        let minute = 1000*60;
        let hour = minute * 60;
        var day = hour * 24;
        let times="";//内容
        let min = time/minute;//分钟
        let hours = time/hour;//天数
        return y + '-' + MM + '-' + d + ' ' + h + ':' + m + ':' + s;
      }

    },
  }
</script>

<style scoped>
  /deep/ .el-tabs__content{
    width: 100%;
    padding: 0px;
    overflow-y: scroll;
    height: calc(815px);
  }
  /deep/ .el-tabs__content::-webkit-scrollbar{
    display: none;
  }

  .left_right{
    width: 90%;
    height: 100%;
    margin: 0 auto;
  }


  a{
    color: #000000;
  }
  a:hover{
    color: #ff6700;
  }
  .openprivate{
    width: 720px;
    overflow: hidden;
  }
  .openprivate:hover{
    width: 720px;
    overflow: hidden;
    background-color: #F4F4F4;
  }
  .title{
  width:540px;
  overflow:hidden;
  text-overflow:ellipsis;
  white-space:nowrap;
  word-break:keep-all;
  color: #a2a2a2;
  }

  /**Orderinfor框架*/
  .Orderinfordiv{
    position: fixed;
    top: 13%;
    left:0;
    right:0;
    bottom: 0;
    margin:0 auto;
    padding: 20px;
    border: 0px solid #ddd;
    z-index:2002;
    overflow: auto;
    display: none;
  }
  .OrderinforForm{
    margin: 0 auto;
    width: 900px;
    background-color: #fff;
    -webkit-box-shadow: #333 0px 5px 5px;
    -moz-box-shadow: #333 0px 5px 5px;
    box-shadow: #333 0px 5px 5px;
  }
  .OrderinforForm a{
    color: #fff;
  }
  .OrderinforForm a:hover{
    color: #d6d6d6;
  }
  .orderxx_p{
  	margin:0px 0 5px 0;
  	color:#909090;
  }

   .playlistbox_botton{
      width: 900px;margin: 0 auto;overflow: hidden;height: 633px;
      overflow-y: scroll;
    }
    /**滚动条样式*/
    .playlistbox_botton::-webkit-scrollbar{
      width: 5px;
    }
    .playlistbox_botton::-webkit-scrollbar-thumb{
      border-radius: 10px;
      -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
      background: #535353;
    }
    .playlistbox_botton::-webkit-scrollbar-thumb{
      -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
      border-radius: 10px;
      background: #EDEDED;
    }
    
    .titleOrder_infor{
    max-width:550px;
    overflow:hidden;
    text-overflow:ellipsis;
    white-space:nowrap;
    word-break:keep-all;
    }
</style>



// WEBPACK FOOTER //
// src/admin/views/consulation_admin/AConsulationList.vue